import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
            <div className="container">
                <div className="nav-wrapper">
                    <div className="logo">
                        <span className="gradient-text">XCO Technologies</span>  
                                </div>

                    <div className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
                        <a href="#home" onClick={() => setMobileMenuOpen(false)}>Home</a>
                        <a href="#vision" onClick={() => setMobileMenuOpen(false)}>Vision</a>
                        <a href="#work" onClick={() => setMobileMenuOpen(false)}>Work</a>
                        <a href="#tech" onClick={() => setMobileMenuOpen(false)}>Tech</a>
                        <a href="#faq" onClick={() => setMobileMenuOpen(false)}>FAQ</a>
                    </div>

                    <button className="cta-button">Get Started</button>

                    <div className="mobile-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                        <span></span><span></span><span></span>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;